/**
 * 드로잉 도구 컴포넌트
 * 펜/지우개, 굵기 조절
 */

import React from 'react';
import { PixelButton } from '../common/PixelButton';

/**
 * DrawingTools Props
 */
interface DrawingToolsProps {
  /** 지우개 모드 여부 */
  isEraser: boolean;
  /** 지우개 모드 토글 */
  onToggleEraser: () => void;
  /** 펜 굵기 */
  penWidth: number;
  /** 펜 굵기 변경 */
  onPenWidthChange: (width: number) => void;
  /** 전체 지우기 */
  onClear: () => void;
}

/**
 * DrawingTools 컴포넌트
 *
 * - 펜/지우개 토글
 * - 선 굵기 조절
 * - 전체 지우기
 */
export const DrawingTools: React.FC<DrawingToolsProps> = ({
  isEraser,
  onToggleEraser,
  penWidth,
  onPenWidthChange,
  onClear,
}) => {
  const widths = [2, 3, 5];

  return (
    <div className="flex items-center justify-between gap-2 mb-2">
      {/* 펜/지우개 토글 */}
      <div className="flex gap-1">
        <PixelButton
          variant={!isEraser ? 'primary' : 'secondary'}
          size="small"
          onClick={onToggleEraser}
          className="text-xs px-2 py-1"
        >
          ✏️
        </PixelButton>
        <PixelButton
          variant={isEraser ? 'primary' : 'secondary'}
          size="small"
          onClick={onToggleEraser}
          className="text-xs px-2 py-1"
        >
          🧹
        </PixelButton>
      </div>

      {/* 펜 굵기 */}
      <div className="flex gap-1">
        {widths.map((w) => (
          <button
            key={w}
            onClick={() => onPenWidthChange(w)}
            className={`
              w-6 h-6 rounded-sm flex items-center justify-center
              border ${penWidth === w ? 'border-[#9bbc0f] bg-gray-700' : 'border-gray-600 bg-gray-800'}
              transition-colors
            `}
          >
            <div
              className="rounded-full bg-white"
              style={{
                width: `${w * 2}px`,
                height: `${w * 2}px`,
              }}
            />
          </button>
        ))}
      </div>

      {/* 전체 지우기 */}
      <PixelButton
        variant="secondary"
        size="small"
        onClick={onClear}
        className="text-xs px-2 py-1"
      >
        🗑️
      </PixelButton>
    </div>
  );
};
